export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileNemAllergia');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileNemAllergia');
    }
}
